import React from "react";
import PropTypes from "prop-types";

export function ImportedSyncEntityModalHeader({ title, subtitle }) {
  return (
    <div style={{ float: "left", paddingBottom: "22px" }}>
      {title}
      {subtitle && (
        <div style={{ fontSize: "72%", fontWeight: "normal" }}>{subtitle}</div>
      )}
    </div>
  );
}
ImportedSyncEntityModalHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

export default ImportedSyncEntityModalHeader;
